import { createSlice } from '@reduxjs/toolkit';
import i18n from '../../i18n/i18n';
import { IOrganizationState } from '../../interface/organizationModel';
import {
  createOrganization,
  fetchCurrencies,
  fetchMyOrganization,
  fetchTeacherStudentCounts,
  updateMyOrganization,
  updateOrganization,
} from '../action/organization.action';

const initialState: IOrganizationState = {
  organization: null,
  isLoading: false,
  error: null,
  teacherCount: null,
  studentCount: null,
  schoolType: null,
  currencies: null,
  createdOrganization: null,
  updatedOrganization: null,
};

const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyOrganization.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.organization = null;
      })
      .addCase(fetchMyOrganization.fulfilled, (state, action) => {
        state.isLoading = false;
        state.organization = action.payload.data.organization;
      })
      .addCase(fetchMyOrganization.rejected, (state, action) => {
        state.isLoading = false;
        state.organization = null;
        state.error =
          (action.payload as any)?.message ||
          i18n.t('toast.failed_to_fetch_organization', 'Failed to fetch organization.');
      })
      .addCase(fetchTeacherStudentCounts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchTeacherStudentCounts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.teacherCount = action.payload.data.teacherRange;
        state.studentCount = action.payload.data.studentRange;
        state.schoolType = action.payload.data.schoolType;
      })
      .addCase(fetchTeacherStudentCounts.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          i18n.t('toast.failed_to_fetch_counts', 'Failed to fetch counts');
      })
      .addCase(fetchCurrencies.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchCurrencies.fulfilled, (state, action) => {
        state.isLoading = false;
        state.currencies = action.payload.data;
      })
      .addCase(fetchCurrencies.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          i18n.t('toast.failed_to_fetch_currencies', 'Failed to fetch currencies');
      })
      .addCase(createOrganization.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createOrganization.fulfilled, (state, action) => {
        state.isLoading = false;
        state.createdOrganization = action.payload;
      })
      .addCase(createOrganization.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          i18n.t('toast.failed_to_create_organization', 'Failed to create organization');
      })
      .addCase(updateOrganization.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateOrganization.fulfilled, (state, action) => {
        state.isLoading = false;
        state.updatedOrganization = action.payload;
      })
      .addCase(updateOrganization.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          i18n.t('toast.failed_to_update_organization', 'Failed to update organization');
      })
      .addCase(updateMyOrganization.pending, (state) => {
        state.isLoading = true;
        state.updatedOrganization = null;
      })
      .addCase(updateMyOrganization.fulfilled, (state, action) => {
        state.isLoading = false;
        state.updatedOrganization = action.payload;
      })
      .addCase(updateMyOrganization.rejected, (state, _action) => {
        state.isLoading = false;
        state.updatedOrganization = null;
      });
  },
});

export default organizationSlice.reducer;
